import React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { insuredApi } from 'services/apis';
import { useParams } from 'react-router';
import InsuredForm from '../insured-form';
import { CreateInsuredPayloadDto } from 'libs/pinnacle-sdk';
import dayjs from 'dayjs';
import { EQueryKeys } from 'constants/query-keys';

const UpdateInsuredForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();

  const { data: insured, isLoading: isFetchingInsured } = useQuery(
    [EQueryKeys.INSURED_BY_ID, id],
    () => insuredApi.getInsuredById({ insuredId: id as string }),
    {
      enabled: !!id,
    }
  );

  const updateInsuredMutation = useMutation<
    void,
    Error,
    CreateInsuredPayloadDto
  >(async (updatedInsured) => {
    await insuredApi.updateInsured({
      insuredId: id as string,
      updateInsuredPayloadDto: updatedInsured,
    });
    await Promise.all([
      queryClient.invalidateQueries([EQueryKeys.INSURED_BY_ID, id]),
      queryClient.invalidateQueries([EQueryKeys.INSURED_LIST]),
    ]);
  });

  return (
    <InsuredForm
      mode="update"
      initialData={
        insured
          ? {
              ...insured,
              sanctionsCompletedDate: insured.sanctionsCompletedDate
                ? dayjs(insured.sanctionsCompletedDate)
                : undefined,
            }
          : undefined
      }
      onSubmit={updateInsuredMutation.mutateAsync}
      isLoading={isFetchingInsured || updateInsuredMutation.isLoading}
    />
  );
};

export default UpdateInsuredForm;
